export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail of gebruikersnaam',
      invalidEmailOrUsername: 'Ongeldig e-mailadres of gebruikersnaam',
      invalidPassword: 'Ongeldig wachtwoord',
      logInToPlanka: 'Inloggen bij Planka',
      noInternetConnection: 'Geen internetverbinding',
      pageNotFound_title: 'Pagina niet gevonden',
      password: 'Wachtwoord',
      projectManagement: 'Projectbeheer',
      serverConnectionFailed: 'Verbinding met de server mislukt',
      unknownError: 'Onbekende fout, probeer het later opnieuw',
      useSingleSignOn: 'Gebruik single sign-on',
    },

    action: {
      logIn: 'Inloggen',
      logInWithSSO: 'Inloggen met SSO',
    },
  },
};
